// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-page__order-summary{display:flex;flex-direction:column;gap:24px}", "",{"version":3,"sources":["webpack://./src/checkout/pages/NewCheckoutPage.scss"],"names":[],"mappings":"AAAA,8BACI,YAAA,CACA,qBAAA,CACA,QAAA","sourcesContent":[".checkout-page__order-summary {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
